import React from "react";
import { SimpleModulePage } from "../modules/SimpleModulePage";

const SectionCard: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = "" }) => (
  <div className={`mx-4 mt-3 rounded-2xl bg-white shadow-sm px-4 py-3 mb-3 border border-slate-100 ${className}`}>{children}</div>
);

interface SettingsPageProps {
  onBack: () => void;
  onMenuClick?: (menu: string) => void;
}

export const SettingsPage: React.FC<SettingsPageProps> = ({ onBack, onMenuClick }) => {
  const handleMenuClick = (menu: string) => {
    if (onMenuClick) {
      onMenuClick(menu);
    } else {
      // 기본 동작: 설정되지 않으면 콘솔에 로그
      console.log('[SettingsPage] Menu clicked:', menu);
    }
  };

  return (
    <SimpleModulePage title="설정" subtitle="(전체 설정)" icon="⚙️" onBack={onBack}>
      {/* 내 정보 섹션 */}
      <SectionCard>
        <div className="text-[13px] font-semibold text-slate-900 mb-3 flex items-center gap-2">
          <span className="text-[18px]">👤</span>
          <span>내 정보</span>
        </div>
        <div className="space-y-0">
          <button
            onClick={() => handleMenuClick('my-info')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors"
          >
            MY 정보
          </button>
          <button
            onClick={() => handleMenuClick('personal-settings')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors"
          >
            허비서 설정
          </button>
          <button
            onClick={() => handleMenuClick('health-diary')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors"
          >
            건강 일기
          </button>
          {/* <button
            onClick={() => handleMenuClick('my-points')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors"
          >
            내 포인트
          </button> */}
          {/* <button
            onClick={() => handleMenuClick('payment-history')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors"
          >
            결제 내역 조회
          </button> */}
          <button
            onClick={() => handleMenuClick('environment-settings')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 hover:bg-slate-50 transition-colors"
          >
            환경설정
          </button>
        </div>
      </SectionCard>

      {/* 건강 정보 섹션 */}
      <SectionCard>
        <div className="text-[13px] font-semibold text-slate-900 mb-3 flex items-center gap-2">
          <span className="text-[18px]">❤️</span>
          <span>건강 정보</span>
        </div>
        <div className="space-y-0">
          <button
            onClick={() => handleMenuClick('body-measurements')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors"
          >
            신체정보
          </button>
          <button
            onClick={() => handleMenuClick('caddy-settlement')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors"
          >
            복약 & 처방전
          </button>
          <button
            onClick={() => handleMenuClick('caddy-coupon')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors"
          >
            식단 정보
          </button>
          <button
            onClick={() => handleMenuClick('caddy-payment')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 hover:bg-slate-50 transition-colors"
          >
            혈당 & 혈압
          </button>
        </div>
      </SectionCard>

      {/* 고객센터 섹션 */}
      <SectionCard>
        <div className="text-[13px] font-semibold text-slate-900 mb-3 flex items-center gap-2">
          <span className="text-[18px]">💬</span>
          <span>고객센터</span>
        </div>
        <div className="space-y-0">
          <button
            onClick={() => handleMenuClick('customer-center')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 border-b border-slate-100 last:border-b-0 hover:bg-slate-50 transition-colors"
          >
            고객센터
          </button>
          <button
            onClick={() => handleMenuClick('event-notice')}
            className="w-full py-3 px-0 text-left text-[14px] text-slate-700 hover:bg-slate-50 transition-colors"
          >
            이벤트 & 공지사항
          </button>
        </div>
      </SectionCard>
    </SimpleModulePage>
  );
};
